module.exports = __webpack_public_path__ + "static/media/baseMeme9thumb.5d8131e8.jpg";